import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { fetchIndustryList } from "../../../Industry/utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";

/**
 * Renders the form component for SkillCategories to add or edit the record.
 *
 * @param {any} props - The props for the component.
 * @param {any} props.form - The form instance for the component.
 * @param {any} props.id - The id for the component.
 * @param {any} props.handleSubmit - The function to handle form submission.
 * @param {any} props.onValuesChange - The function to handle form values change.
 * @param {any} props.editValues - The values to edit for the component.  
 * @return {ReactElement} The form component for SkillCategories.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {

  const dispatch = useAppDispatch();

  const [industryList, setIndustryList] = useState<any>([]);

  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }

    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);


  }, [editValues, form]);

  const onFinish = (data: any) => {
    if (typeof data.description !== "string") {
      data.description = data?.description?.level?.content;
    }
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="code"
              label="Code"
              rules={rules.code()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              required
              label="Industry"
              name="industry_id"
              showSearch
              className="singleSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />


          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="description"
              label="Description"
              initValue={form.getFieldValue("description")}
              editorChange={(e: any) => {
                form.setFieldsValue({ description: e });
                onValuesChange();
              }}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
